module.exports = __webpack_public_path__ + "static/media/settings-white.df8d2b5e.svg";